import {
  Box,
  Button,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableContainer,
  TablePagination,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import StoreMallDirectoryIcon from "@material-ui/icons/StoreMallDirectory";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { connect } from "react-redux";
import { actions } from "../../../../redux/actions/alert";
import { Link } from "react-router-dom";
import { ProductService } from "../../../../services/product.service";
import styles from "../../../../styles/global-styles";
import ProductTableToolbar from "../../../shared/table/ProductTableToolbar";
import TableHeadProduct from "../../../shared/table/TableHeadProduct";
import { clickCheckbox, selectAllCheckbox } from "../../../../_utils/checkBox";
import { headCellCashCardProduct } from "../../../stateless/headTables/HeadCellCashCardProduct";
import { changeRowsPerPage } from "../../../../_utils/utils";
import SiteSelect from "../../../shared/selects/SiteSelect";
import CashCardDetailRow from "../../../stateless/CashCardDetailRow";
import DistributionDialog from "../../modals/DistributionDialog";

const usetSyles = makeStyles((theme) => ({
  title: styles.title,
  subtitle: styles.subtitle,
  label: styles.label,
  rightButton: styles.buttonRightHeader,
  backgroundIcon: styles.backgroundIcon,
  link: styles.link,
  customSelect: styles.customSelect,
  table: {
    minWidth: 750,
  },
  rowSelected: {
    "&:hover": {
      backgroundColor: "#ccebff !important",
    },
  },
}));

const CashCardDetail = ({ cardCatalogueId, addAlert, detailAlert }) => {
  const classes = usetSyles();

  const [cashCardProducts, setCashCardProducts] = useState([]);
  const [detailProduct, setDetailProduct] = useState({});
  const [openModal, setOpenModal] = React.useState({});
  const [queryParams, setqueryParams] = useState({
    cardCatalogueId,
    inDistribution: 0,
    productSold: 0,
  });
  /** Pagination */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  /**Check box options */
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    loadCashCards();
  }, []);

  const loadCashCards = async () => {
    try {
      const { data } = await ProductService.getProductByCashCardWithParams(
        queryParams
      );
      console.log("data cashCard", data);
      /** Exist at least one accesory product  (created )in store */
      if (data.length && data[0]) {
        setCashCardProducts(data);
        const {
          cash_card: {
            card_catalogue: { name, amount },
          },
        } = data[0];
        setDetailProduct({ ...detailProduct, name, amount });
      } else {
        const errorObj = {
          noAvailable: "No hay productos en el almacén actualmente",
        };
        throw errorObj;
      }
    } catch (error) {
      console.log(error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: error.noAvailable ? "warning" : "error",
        message: error.noAvailable ? error.noAvailable : error.msgs,
      });
    }
  };

  const handleQuerySelected = (key, value) => {
    setqueryParams({ ...queryParams, [key]: value === "none" ? "" : value });
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleOnClose = () =>
    setOpenModal({ ...openModal, open: false, option: undefined });

  const handleClickCheckbox = (cashCardId) => {
    setSelected(clickCheckbox(cashCardId, selected));
  };

  const handleActionTrigered = (actionSucceed, actionMessage, option) => {
    addAlert({ showAlert: true });
    if (option === "update") {
      setSelected([]);
    }
    if (actionSucceed) {
      loadCashCards();
      detailAlert({
        severity: "success",
        message: actionMessage,
        time: 2000,
      });
    } else {
      console.log("message", actionMessage);
      detailAlert({
        severity: "error",
        message: actionMessage,
      });
    }
  };

  const searchProductByFilters = async () => {
    console.log("queryParams", queryParams);
    try {
      const { data } = await ProductService.getProductByCashCardWithParams(
        queryParams
      );
      console.log("data from filters response", data);
      if (data.length) setCashCardProducts(data);
      else {
        addAlert({ showAlert: true });
        detailAlert({
          severity: "warning",
          message: "No se encontraron productos con los filtros seleccionados",
        });
      }
    } catch (error) {
      console.log(error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: error.msgs || "Error al procesar tu solicitud",
      });
    }
  };

  return (
    <>
      <div style={{ display: "inline-flex" }}>
        <ArrowBackIosIcon color="primary" />
        <Typography variant="body1" component={"div"}>
          <Box mb={3}>
            {" "}
            <Link
              to="/dashboard/inventario/tarjetas-saldo"
              className={classes.link}
            >
              Regresar
            </Link>
          </Box>
        </Typography>
      </div>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item>
          <Typography className={classes.subtitle}>
            Inventario tarjeta de saldo{" "}
            {Object.values(detailProduct).length && (
              <>
                {detailProduct.name} ${detailProduct.amount}
              </>
            )}
          </Typography>
        </Grid>
        <Grid item>
          <SiteSelect site={handleQuerySelected} showNone />
        </Grid>
        <Grid item>
          <Button
            className={classes.rightButton}
            variant="contained"
            onClick={() => searchProductByFilters()}
            color="primary"
            endIcon={<SearchIcon color="secondary" />}
          >
            Filtrar
          </Button>
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        spacing={4}
        style={{ marginTop: 50 }}
      >
        <Grid item>
          <Button
            className={classes.rightButton}
            onClick={() =>
              setOpenModal({ ...openModal, open: true, option: 1 })
            }
            disabled={!selected.length}
            variant="contained"
            color="primary"
            endIcon={<StoreMallDirectoryIcon color="secondary" />}
          >
            Distribución
          </Button>
        </Grid>
        <Grid item>
          <Link
            to={{
              pathname: `../inventario/captura`,
              state: { tabOption: 4 },
            }}
            className={classes.link}
          >
            <Button
              className={classes.rightButton}
              onClick={() =>
                setOpenModal({ ...openModal, open: true, option: 2 })
              }
              variant="contained"
              color="primary"
              endIcon={<AddCircleIcon color="secondary"></AddCircleIcon>}
            >
              Nuevo stock
            </Button>
          </Link>
        </Grid>
      </Grid>

      <ProductTableToolbar
        productsSelected={selected}
        title={""}
        label={" producto(s) seleccionados"}
      />
      <TableContainer style={{ marginTop: 20 }}>
        {cashCardProducts.filter(({ cash_card }) => cash_card.siteId != null)
          .length > 0 ? (
          <Table
            className={classes.table}
            size={"medium"}
            aria-label="collapsible table"
          >
            <TableHeadProduct
              numSelected={selected.length}
              headCells={headCellCashCardProduct}
              onSelectAllClick={(e) =>
                setSelected(selectAllCheckbox(e, cashCardProducts, "cash_card"))
              }
              rowCount={cashCardProducts.length}
            />
            <TableBody>
              {cashCardProducts
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((product, id) => {
                  return (
                    <CashCardDetailRow
                      key={id}
                      selectedExam={selected}
                      row={product}
                      accesorySelected={handleClickCheckbox}
                      productRemoved={handleActionTrigered}
                    />
                  );
                })}
            </TableBody>
          </Table>
        ) : (
          <Typography
            variant="h6"
            component="h4"
            style={{ marginTop: 50 }}
            className={classes.subtitle}
          >
            No se encontraron tarjetas de saldo, agregar nuevo stock
          </Typography>
        )}
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={cashCardProducts.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={(event) => {
          const { rowsPerPage, page } = changeRowsPerPage(event);
          setRowsPerPage(rowsPerPage);
          setPage(page);
        }}
      />

      {openModal.open && openModal.option === 1 && (
        <DistributionDialog
          title="accesorios"
          open={openModal.open}
          onClose={handleOnClose}
          detailProduct={detailProduct}
          productsIdSelected={selected}
          productType="cashCard"
          bulkCashCard={cashCardProducts}
        />
      )}
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(CashCardDetail);
